import { createSlice } from "@reduxjs/toolkit"

export const Utilities = createSlice({
    name : 'utilities',
    initialState : {
        rex_data_permissions_type_users: [],
        rex_data_permissions_type_users_clone: [],
        rex_validate_permissions: null,
        rex_data_countries: [],
        rex_selected_country: null,
        rex_validate_countries: null,
    },
    reducers : {
        storeDataPermissionsTypeUsers: (state, action) => {
            state.rex_data_permissions_type_users = action.payload
        },
        storeDataPermissionsTypeUsersClone: (state, action) => {
            state.rex_data_permissions_type_users_clone = action.payload
        },
        storeValidatePermissions: (state, action) => {
            state.rex_validate_permissions = action.payload
        },
        storeDataCountries: (state, action) => {
            state.rex_data_countries = action.payload
        },
        storeSelectedCountry: (state, action) => {
            state.rex_selected_country = action.payload
        },
        storeValidateCountries: (state, action) => {
            state.rex_validate_countries = action.payload
        },
    }
})

export default Utilities.reducer
export const { 
    storeDataPermissionsTypeUsers, 
    storeDataPermissionsTypeUsersClone, 
    storeValidatePermissions, 
    storeDataCountries, 
    storeSelectedCountry, 
    storeValidateCountries, 
} = Utilities.actions